import React, { useState, useEffect } from "react";
import { FloatButton } from "antd";
import { Icon } from "@mdi/react";
import { mdiClose, mdiChevronUp, mdiWhatsapp, mdiFacebook, mdiFacebookMessenger } from "@mdi/js";

const WHATSAPP_URL = "https://go.daisi.app/0e1f0c7c43";
const FB_MESSENGER_URL = "https://m.me/200092683344154";

const BTN = 54;
const SUB = 50;
const R = 24;
const GAP = 12;
const SUB_R = R + (BTN - SUB) / 2;

interface FloatingChatButtonProps {
  isItineraryShowPage?: boolean;
  showBackTop?: boolean;
  bottomBase?: number;
  onToggle?: (isOpen: boolean) => void;
  hasVoiceOverAd?: boolean;
}

const FloatingChatButton: React.FC<FloatingChatButtonProps> = ({
  isItineraryShowPage = false,
  showBackTop = false,
  bottomBase,
  onToggle,
  hasVoiceOverAd = false
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("chat-menu-open", isExpanded);
    return () => document.body.classList.remove("chat-menu-open");
  }, [isExpanded]);

  // Inherit dynamic layout offset baseline calculations passed from parent wrapper
  const base = bottomBase ?? (isItineraryShowPage ? 100 : 24);
  
  const chatBottom: string | number = isItineraryShowPage
    ? "var(--floating-chat-bottom, 100px)"
    : base;
    
  const scrollTopBottom: string | number = isItineraryShowPage
    ? "var(--floating-scroll-bottom, 160px)"
    : hasVoiceOverAd
      ? base + 132
      : base + 66;

  //temporary replace whatsapp position
  const fbBottom: string | number = isItineraryShowPage
    ? `calc(var(--floating-chat-bottom, 100px) + ${BTN + GAP}px)`
    : base + BTN + GAP;
  
  //if later turn on, uncomment this, and adjust above to waBottom
  // const fbBottom: string | number = isItineraryShowPage
  //   ? `calc(var(--floating-chat-bottom, 100px) + ${BTN + GAP + SUB + GAP}px)`
  //   : base + BTN + GAP + SUB + GAP;

  const handleToggle = () => {
    setIsExpanded((prev) => {
      const nextState = !prev;
      if (onToggle) onToggle(nextState); // Notify parent
      return nextState;
    });
  };

  const handleFBClick = () => {
    window.open(FB_MESSENGER_URL, "_blank", "noopener,noreferrer");
    setIsExpanded(false);
  };

  const handleWhatsAppClick = () => {
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
    setIsExpanded(false);
  };

  return (
    <>
      {isExpanded && (
        <div className="floating-chat-overlay" onClick={() => {
          setIsExpanded(false);
          if (onToggle) onToggle(false);
        }} />
      )}
      
      {showBackTop && !isExpanded && (
        <FloatButton.BackTop
          icon={<Icon path={mdiChevronUp} size="28px" />}
          style={{
            insetInlineEnd: R,
            bottom: scrollTopBottom,
            width: BTN,
            height: BTN,
            zIndex: 997,
          }}
        />
      )}

      {isExpanded && (
        <>
          {/* <FloatButton
            icon={<Icon path={mdiWhatsapp} size="26px" color="#333" />}
            tooltip="WhatsApp"
            onClick={handleWhatsAppClick}
            style={{
              insetInlineEnd: SUB_R,
              bottom: waBottom,
              width: SUB,
              height: SUB,
              zIndex: 997,
            }}
          /> */}
          <FloatButton
            icon={<Icon path={mdiFacebookMessenger} size="26px" color="#333" />}
            tooltip="Facebook Messenger"
            onClick={handleFBClick}
            style={{
              insetInlineEnd: SUB_R,
              bottom: fbBottom,
              width: SUB,
              height: SUB,
              zIndex: 997,
            }}
          />
        </>
      )}

      <div
        className={`floating-chat-button${isExpanded ? " is-open" : ""}`}
        onClick={handleToggle}
        style={{ bottom: chatBottom }}
      >
        {isExpanded ? (
          <Icon path={mdiClose} size="26px" color="#DC1A22" />
        ) : (
          <img
            src="/iceholidays-assets/images/icons/gd-support.png"
            alt="Chat with us"
            style={{ width: "100%", height: "100%", display: "block" }}
          />
        )}
      </div>
    </>
  );
};

export default FloatingChatButton;